import React from 'react';
import classnames from 'classnames';
import { Avatar } from '@highlight-ui/avatar';

import MultiLineOptionLabel from './MultiLineOptionLabel';
import { SelectOption, SelectOptionLabelProps } from '../../../types';
import styles from './AvatarOptionLabel.module.scss';

function AvatarOptionLabel<T extends SelectOption>({
  option,
  highlightedText,
  selected,
  disabled,
}: SelectOptionLabelProps<T>) {
  return (
    <div className={styles.wrapper}>
      <Avatar
        src={option.avatar}
        name={option.label}
        containerClassname={classnames(styles.avatar, {
          [styles.disabledAvatar]: option.disabled,
        })}
        imageLoading={option?.imageLoading}
      />

      <div className={styles.labelsWrapper}>
        <MultiLineOptionLabel
          highlightedText={highlightedText}
          option={option}
          selected={selected}
          disabled={disabled}
          truncateText
        />
      </div>
    </div>
  );
}

export default AvatarOptionLabel;
